import axios from 'axios';
import moment from 'moment';
import { pick } from 'lodash';
import api from '../../lib/axios';
import store from '../index';

// function dataURLToFile(data, fileName) {
//   const tokens = data.split(',');
//   const mime = tokens[0].match(/:(.*?);/)[1];
//   const bstr = atob(tokens[1]);
//   let n = bstr.length;
//   const buffer = new Uint8Array(n);

//   // eslint-disable-next-line no-cond-assign
//   while ((n -= 1) !== 0) {
//     buffer[n] = bstr.charCodeAt(n);
//   }

//   return new File([buffer], fileName, { type: mime });
// }

function convertFormation(formation, type) {
  const result = {
    teamFormationId: formation.teamFormation.id,
    canvas: formation.canvas,
    canvasImage: formation.canvasImage,
    type,
    players: Object.entries(formation.players)
      .map(([order, value]) => ({
        matchPlayerId: value.order,
        order: Number(order),
      }))
      .filter(Boolean),
  };

  if (formation.id) result.id = formation.id;

  return result;
}

export default {
  export({ commit, rootState }, { json, image }) {
    if (rootState['matches-editor'].kickIndex !== null) {
      const index = rootState['matches-editor'].kickIndex;
      commit('exportKickCanvas', { index, json });
      commit('exportKickCanvasImage', { index, image });
      return;
    }

    if (!rootState['matches-editor'].moduleKey) return;
    const key = rootState['matches-editor'].moduleKey;

    commit('exportCanvas', { key, json });
    commit('exportCanvasImage', { key, image });
  },

  async request({ commit }, payload) {
    try {
      return api(payload);
    } catch (err) {
      commit('handleError', err);
    }

    return null;
  },

  async SettingConvocatedPlayersBasedonRole({ commit }, id) {
    api
      .get(`matches/ConvocatedplayersFilteredOnBasisRole/${id}`)
      .then(res => {
        commit('SetConvocatedPlayersBasedonRole', JSON.parse(JSON.stringify(res.data)));
      })
      .catch(err => {
        parseResponseErrors(err);
      });
  },

  async fetchPlayers({ commit, dispatch }) {
    const response = await dispatch('request', {
      method: 'get',
      url: 'players/basicInfo?active=1',
    });
    commit('players', response.data);
  },

  async fetchFormations({ commit, dispatch }) {
    const response = await dispatch('request', {
      method: 'get',
      url: 'matches/formations',
    });
    commit('formations', response.data);
  },

  async fetchMatch({ commit, dispatch }, id) {
    const response = await dispatch('request', {
      method: 'get',
      url: `matches/${id}`,
    });
    commit('match', response.data);
  },

  fetchAll({ commit }, id) {
    const basicInfo = `players/basicInfo${id ? `?match_id=${id}` : ''}`;
    const calls = [
      api.get(basicInfo),
      api.get('matches/formations'),
      api.get('matches/backgrounds'),
      api.get('matches/objects'),
    ];

    if (id) calls.push(api.get(`matches/${id}`));

    return axios
      .all(calls)
      .then(
        axios.spread((players, formations, backgrounds, objects, match) => {
          commit('players', {
            players: players.data,
            match,
          });
          commit('formations', formations.data);
          commit('matches-editor/setBackgrounds', backgrounds.data, { root: true });
          commit('matches-editor/setObjects', objects.data, { root: true });
          if (match) {
            commit('match', match.data);
            commit('buildForm', match.data);
          } else {
            commit('setPlayersNumber');
          }
        }),
      )
      .catch(err => commit('handleError', err));
  },

  async submit({ state, getters }, id) {
    const data = pick(state.form, [
      'type',
      'duration',
      'players',
      'opponentName',
      'home',
      'notes',
      'homeGoals',
      'opponentGoals',
      'homeSubstitutions',
      'opponentSubstitutions',
      'homeAdmonitions',
      'opponentAdmonitions',
      'homeExpulsions',
      'opponentExpulsions',
      'scuolaCalcio',
      'distinctInfos',
    ]);

    // Match players
    data.homePlayers = Object.values(state.form.homePlayers);
    const opponentPlayers = { ...state.form.opponentPlayers };
    delete opponentPlayers[0];
    data.opponentPlayers = Object.values(opponentPlayers);

    // Dates
    if (state.form.day) data.day = state.form.day;
    data.playedAt = moment(state.form.playedAt).format('YYYY-MM-DD HH:mm');

    // Convocations
    if (Object.keys(state.form.convocations).length > 0) {
      data.convocations = [];
      Object.entries(state.form.convocations).forEach(([playerId, convocated]) => {
        if (convocated && getters.availableHomePlayersObject[playerId]) {
          data.convocations.push(getters.availableHomePlayersObject[playerId].infos[0].id);
        }
      });
    }
    data.convocationPlace = state.form.convocationPlace;

    // Formations
    data.modules = [];
    if (state.form.homeModule.teamFormation) {
      data.modules.push(convertFormation(state.form.homeModule, 0));
    }
    if (state.form.opponentModule.teamFormation) {
      data.modules.push(convertFormation(state.form.opponentModule, 1));
    }
    if (state.form.homeModule2.teamFormation) {
      data.modules.push(convertFormation(state.form.homeModule2, 2));
    }

    data.kicks = state.form.kicks;

    return api.post(`matches${id ? `/${id}` : ''}`, data);
  },
};



// WEBPACK FOOTER //
// ./src/store/matches/actions.js